import { Component, inject, input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';
import { NgIf } from '@angular/common';
import { NzOptionComponent, NzSelectComponent } from 'ng-zorro-antd/select';

@Component({
  selector: 'app-language-switcher',
  standalone: true,
  imports: [
    FormsModule,
    TranslateModule,
    SvgIconComponent,
    NgIf,
    NzSelectComponent,
    NzOptionComponent
  ],
  templateUrl: './language-switcher.component.html',
  styleUrl: './language-switcher.component.scss'
})
export class LanguageSwitcherComponent implements OnInit {
  private translateService = inject(TranslateService);
  lang!: string | null;
  dropdownOpen = false;
  disableOnClickCb = false;
  dashboardLayout = input(false, { alias: 'dashboardLayout' });

  ngOnInit(): void {
    if (localStorage.getItem('lang')) {
      this.lang = localStorage.getItem('lang');
    }
  }

  ngAfterViewInit() {
    this.changeDirection(localStorage.getItem('lang') ?? 'en');
  }

  onDropdownArrowClick(e: Event) {
    if (!this.disableOnClickCb) {
      this.dropdownOpen = true;
    }
  }

  onDropdownBlur() {
    this.dropdownOpen = false;
    this.disableOnClickCb = true;

    setTimeout(() => {
      this.disableOnClickCb = false;
    }, 200);
  }

  switchLanguage() {
    const lang = localStorage.getItem('lang');
    this.changeLanguage(lang === 'ar' ? 'en' : 'ar');
  }

  changeLanguage(lang: string): void {
    localStorage.setItem('lang', lang);
    this.translateService.use(lang);
    this.translateService.setDefaultLang(lang);
    this.changeDirection(lang);
  }

  changeLanguageByIcon(e: MouseEvent) {
    e.stopPropagation();
    this.switchLanguage();
  }

  changeDirection(lang: string) {
    const htmlTag = document.getElementsByTagName('html')[0] as HTMLHtmlElement;
    htmlTag.dir = lang === 'ar' ? 'rtl' : 'ltr';
    htmlTag.lang = lang ?? 'en';
  }
}
